"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIZARD_PLAN_PRIORITY = void 0;
exports.WIZARD_PLAN_PRIORITY = {
    manualPackageEditor: 2000,
    datasheetCatalogueOnboarding: 1500,
    packageDataAdjudication: 1750,
    ingest: 1000,
    cliDispatch: 1000,
    dataScience: 100,
};
//# sourceMappingURL=plan-priority.js.map